import { render, staticRenderFns } from "./OrdineDiServizio.vue?vue&type=template&id=0e4d6992"
import script from "./OrdineDiServizio.vue?vue&type=script&lang=js"
export * from "./OrdineDiServizio.vue?vue&type=script&lang=js"
import style0 from "./OrdineDiServizio.vue?vue&type=style&index=0&id=0e4d6992&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports